module.exports = __webpack_public_path__ + "static/media/log-out-icon-active.4fdfd165.svg";